import { useFormContext } from 'react-hook-form';

interface IInputCardHolder {
  error: spreedly.SpreedlyError['message'];
  className?: string;
}

const getErrorTranslation = (error: string) => {
  // eslint-disable-next-line quotes
  if (error === "First name can't be blank") {
    return 'El titular de la tarjeta no puede estar en blanco';
  }
  return 'El titular de la tarjeta introducido no es válido';
};

export const InputCardHolder = (props: IInputCardHolder) => {
  const { error, className } = props;

  const form = useFormContext<IFormFields>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    form.setValue('full_name', e.target.value);
  };

  return (
    <div className={`co-flex co-w-full co-flex-col co-gap-[8px] ${className}`}>
      <LabelCardHolder />
      <div className="co-flex co-flex-col co-gap-[4px]">
        <input
          type="text"
          id="full_name"
          placeholder="Escríbelo como aparece en la tarjeta"
          className="co-w-full co-h-[40px] co-border-[1px] co-border-[#B4C2CB] co-p-[12px] co-pl-16px co-bg-white co-rounded-[6px] co-box-border co-text-body1 co-leading-[20px] co-font-montserrat"
          {...form.register('full_name', {
            onChange(event) {
              handleChange(event);
            }
          })}
        />
        <InputError error={error} />
      </div>
    </div>
  );
};

const LabelCardHolder = () => {
  return (
    <label
      className="co-flex co-w-fit co-text-[12px] co-font-semibold co-leading-[16px] co-text-[#363F45]"
      htmlFor="full_name"
    >
      Títular de la tarjeta
    </label>
  );
};

const InputError = ({
  error
}: {
  error: spreedly.SpreedlyError['message'];
}) => {
  if (!error) return <></>;

  const translatedError = getErrorTranslation(error);

  return (
    <p
      className="co-px-[8px] co-text-[12px] co-leading-[16px] co-font-medium co-text-[#E90200]"
      id="full_name"
    >
      {translatedError}
    </p>
  );
};
